import { render, staticRenderFns } from "./UiSegmentedControl.vue?vue&type=template&id=fe9efe6a"
import script from "./UiSegmentedControl.vue?vue&type=script&lang=js"
export * from "./UiSegmentedControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports